import { TypographyColor } from 'melp-design/components';
import { AdminCardStatus } from './admin-cards.types';

export const COLOR_BY_STATUS: Record<AdminCardStatus, TypographyColor> = {
  enabled: 'success',
  disabled_by_melp: 'textSecondary',
  disabled_by_provider: 'error',
};
